/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Axios from "axios";
// Material UI
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { TextField, Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Box from "@material-ui/core/Box";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import creditBlack from "../Assets/Icons/credit-card.png";
import FormControl from "@mui/material/FormControl";
import clsx from "clsx";
import credit from "../Assets/Icons/creditWhitesmall.png";
import phone from "../Assets/Icons/phone.png";
import cashbackicon from "../Assets/Icons/cashbackicon.png";
// Pages
import StateContext from "../StateContext";
import GoSellElementsTrans from "./GoSell";
import DispatchContext from "../DispatchContext";
import Invoice from "./Invoice";
import Navbar from "../Components/Navbar";
import LoginModal from "../Components/loginModal/loginModal";
import CustomizedDialogs from "../Components/CustomizedDialogs";
import MiscBanner from "../Components/MiscBanner";
import LoaderAnimation from "../Components/LoaderAnimation";
import LoginDialog from "../Components/LoginDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
// import InvoiceDesktop from "../Components/InvoiceDesktop";
// import InvoiceReadyPayment from "../Components/InvoiceReadyPayment";
import vendorsConfig from "../vendorsConfig";
import Backdrop from "@mui/material/Backdrop";


// Cookies functions
import { getCookie, setCookie, erase } from "../Functions/cookieFunction";

import { ta } from "date-fns/locale";
import { useTranslation, withTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    height: {
        height: "100vh",
    },
    wrapper: {
        marginTop: "1.5rem",
        position: "relative",
        width: "100%",
    },
    buttonSuccess: {
        backgroundColor: green[500],
        "&:hover": {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        color: green[500],
        position: "absolute",
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const OldPayment = () => {
    const {t} = useTranslation()
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const [payWithValue, setPayWithValue] = useState("");
    const [paymentSource, setPaymentSource] = useState("");
    const { type, id } = useParams();
    const [invoiceDetails, setInvoiceDetails] = useState("");
    const classes = useStyles();
    const childRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [field, setField] = useState({});
    const [buttonLoading, setButtonLoading] = useState(false);
    const [pLoading, setPLoading] = useState(false);
    // const [cardResponse, setCardResponse] = useState([])
    const [tapId, setTapId] = useState("");
    const [cardStatus, setCardStatus] = useState("");
    const [success, setSuccess] = useState(false);
    const history = useHistory();
    const [amount, setAmount] = useState();
    const [paymentServiceId, setPaymentServiceId] = useState("");
    const [customer, setCustomer] = useState({});
    const [tryAgain, setTryAgain] = useState(false)
    const [alertMessage, setAlertMessage] = useState({
        open: false,
        message: "",
        alertSuccess: false,
    });
    const [store, setStore] = useState([]);
    const [additionalInfo, setAdditionalInfo] = useState(false);
    const [formData, setFormData] = useState({});
    const matches = useMediaQuery("(min-width:600px)");
    const [selectedCard, setSelectedCard] = useState([]);

    useEffect(() => {
        if (appState.profile) {
            setField({
                ...field,
                name: appState.profile.name,
                email: appState.profile.email,
                mobile_no: appState.profile.mobile_no,
            });
        }
    }, [appState.profile]);

    const handlePaymentChange = (event) => {

        setPayWithValue(event.target.value);

    };

    const payInvoices = async () => {
        appDispatch({
            type: 'Set_FreezScreen',
            freezScreen: true
        })
        if (type == "qp") {
            if (payWithValue == "wallet" || payWithValue == "knet" || payWithValue == "card") {
                try {
                    const response = await Axios.post(
                        `${process.env.REACT_APP_API_URL}order_invoice/offline`,
                        {
                            country_code: "965",
                            number: appState.loggedIn
                                ? appState.profile.number
                                : formData.number,
                            name: appState.loggedIn
                                ? appState.profile.userFirstName
                                : customer.name
                                    ? customer.name
                                    : formData.name ? formData.name : `Customer${Date.now()}`,
                            email: appState.loggedIn
                                ? appState.profile.email
                                : customer.email
                                    ? customer.email
                                    : formData.email,
                            store_slug: id,
                            customer_id: appState.loggedIn ? appState.profile.userId : "",
                            amount: amount,
                            payment_source: payWithValue ? payWithValue : null,
                            token: tapId ? tapId : null,
                        }
                    )
                    if (response.data.success == true) {
                        const win = window.open(`${response.data.data.url}`, "_self");
                        win.focus();
                        localStorage.removeItem("formData");
                        localStorage.removeItem("fields");
                        setTapId(null)

                    } else if (response.data.success == false) {

                        setAlertMessage({
                            open: true,
                            message: `${response.data.message}: ${response.data.data}`,
                            alertSuccess: false,
                        });
                        appDispatch({
                            type: 'Set_FreezScreen',
                            freezScreen: false
                        });

                        setPLoading(false);
                    }
                    // // console.log(response);
                } catch (e) {
                    setAlertMessage({
                        open: true,
                        message: "Please try again!",
                        alertSuccess: false,
                    });
                    appDispatch({
                        type: 'Set_FreezScreen',
                        freezScreen: false
                    })

                    // console.log(e);
                }
            }
            else {
                try {
                    const response = await Axios.post(
                        `${process.env.REACT_APP_API_URL}order_invoice/offline`,
                        {
                            country_code: "965",
                            number: appState.loggedIn
                                ? appState.profile.number
                                : formData.number,
                            name: appState.loggedIn
                                ? appState.profile.userFirstName
                                : customer.name
                                    ? customer.name
                                    : formData.name ? formData.name : `Customer${Date.now()}`,
                            email: appState.loggedIn
                                ? appState.profile.email
                                : customer.email
                                    ? customer.email
                                    : formData.email,
                            store_slug: id,
                            customer_id: appState.loggedIn ? appState.profile.userId : "",
                            amount: amount,
                            payment_source: "save_card",
                            cust: payWithValue,
                        }
                    )
                    if (response.data.success == true) {
                        const win = window.open(`${response.data.data.url}`, "_self");
                        win.focus();
                        localStorage.removeItem("formData");
                        localStorage.removeItem("fields");
                        setTapId(null)

                    } else if (response.data.success == false) {

                        setAlertMessage({
                            open: true,
                            message: `${response.data.message}: ${response.data.data}`,
                            alertSuccess: false,
                        });
                        appDispatch({
                            type: 'Set_FreezScreen',
                            freezScreen: false
                        });

                        setPLoading(false);
                    }
                    // // console.log(response);
                } catch (e) {
                    setAlertMessage({
                        open: true,
                        message: "Please try again!",
                        alertSuccess: false,
                    });
                    appDispatch({
                        type: 'Set_FreezScreen',
                        freezScreen: false
                    })

                    // console.log(e);
                }
            }

        }

        if (type == "in") {
            if (payWithValue == "wallet" || payWithValue == "knet" || payWithValue == "card") {
                try {
                    const response = await Axios.post(
                        `${process.env.REACT_APP_API_URL}order_invoice/pay`,
                        {
                            country_code: "965",
                            number: appState.loggedIn
                                ? appState.profile.number
                                : formData.number,
                            name: appState.loggedIn
                                ? appState.profile.userFirstName
                                : formData.name ? formData.name : `Customer${Date.now()}`,
                            email: appState.loggedIn
                                ? appState.profile.email
                                : formData.email != undefined ? formData.email : 'gest@enambill.com',
                            customer_id: appState.loggedIn ? appState.profile.userId : "",
                            invoice_id: id,
                            amount: amount,
                            payment_source: payWithValue ? payWithValue : null,
                            token: tapId ? tapId : null,
                        }
                    );
                    if (response.data.success == true) {
                        const win = window.open(`${response.data.data.url}`, "_self");
                        win.focus();
                        localStorage.removeItem("formData");
                        localStorage.removeItem("fields");
                        setTapId(null)
                    } else if (response.data.success == false) {
                        setAlertMessage({
                            open: true,
                            message: `${response.data.message}: ${response.data.data}`,
                            alertSuccess: false,
                        });
                        appDispatch({
                            type: 'Set_FreezScreen',
                            freezScreen: false
                        })
                    }
                    // // console.log(response);
                } catch (e) {
                    setAlertMessage({
                        open: true,
                        message: "Please try again!",
                        alertSuccess: false,
                    });
                    appDispatch({
                        type: 'Set_FreezScreen',
                        freezScreen: false
                    });

                    // console.log(e);
                }

            } else {

                try {
                    const response = await Axios.post(
                        `${process.env.REACT_APP_API_URL}order_invoice/pay`,
                        {
                            country_code: "965",
                            number: appState.loggedIn
                                ? appState.profile.number
                                : formData.number,
                            name: appState.loggedIn
                                ? appState.profile.userFirstName
                                : formData.name ? formData.name : `Customer${Date.now()}`,
                            email: appState.loggedIn

                                ? appState.profile.email
                                : formData.email != undefined ? formData.email : 'gest@enambill.com',
                            invoice_id: id,
                            amount: amount,
                            payment_source: "save_card",
                            card_id: payWithValue,
                            customer_id: appState.loggedIn ? appState.profile.userId : "",

                        }
                    );
                    if (response.data.success == true) {
                        const win = window.open(`${response.data.data.url}`, "_self");
                        win.focus();
                        localStorage.removeItem("formData");
                        localStorage.removeItem("fields");
                        setTapId(null)
                    } else if (response.data.success == false) {
                        setAlertMessage({
                            open: true,
                            message: `${response.data.message}: ${response.data.data}`,
                            alertSuccess: false,
                        });
                        appDispatch({
                            type: 'Set_FreezScreen',
                            freezScreen: false
                        })
                    }
                    // // console.log(response);
                } catch (e) {
                    setAlertMessage({
                        open: true,
                        message: "Please try again!",
                        alertSuccess: false,
                    });
                    appDispatch({
                        type: 'Set_FreezScreen',
                        freezScreen: false
                    });

                    // console.log(e);
                }
            }

        }
    };
    const getStore = async (slug) => {
        setIsLoading(true);
        try {
            const response = await Axios.get(
                `${process.env.REACT_APP_API_URL}${slug}`
            );
            await setStore({
                ...store,
                cover: response.data.data.business.cover,
                business_name: response.data.data.business.name,
                logo: response.data.data.business.logo,
                key: response.data.data.keys.tap,
                payments: response.data.data.payments
            });
            setIsLoading(false);

            // // console.log("store", response);
        } catch (e) {
            setAlertMessage({
                open: true,
                message: e,
                alertSuccess: false,
            });
        }
    };
    const handleSubmit = (event) => {
        appDispatch({
            type: 'Set_FreezScreen',
            freezScreen: true
        })
        event.preventDefault();
        localStorage.setItem("formData", JSON.stringify(formData));
        if (payWithValue != undefined) {

            if (payWithValue == "card") {
                if (tapId != undefined && tapId != "") {
                    payInvoices();
                } else {
                    childRef.current.submitRequest();
                }
            }
            else {
                payInvoices();
            }
        } else {
            setAlertMessage({
                open: true,
                message: "Please select any payment method!",
                alertSuccess: false,
            });
        }
    };

    const orderInvoiceIn = async () => {
        setIsLoading(true);

        if (type === "in") {
            try {
                const response = await Axios.get(
                    `${process.env.REACT_APP_API_URL}order_invoice/${id}`
                );
                // // console.log("invoice in payment",response);
                if (response.data.success) {

                    // console.log(response, "order_invoice");
                    var slug = await response.data.data.business.slug;
                    setAmount(response.data.data.invoiceable.amount);
                    setCustomer(response.data.data.customer);
                    setInvoiceDetails(response.data.data);
                    if (
                        response.data.data.status === "Paid" ||
                        response.data.data.status === "Failed"
                    ) {
                        setIsLoading(true);
                    }
                    // setIsLoading(false);
                    getStore(slug);

                } else {
                    setAlertMessage({
                        open: true,
                        message: response.data.message,
                        alertSuccess: false,
                    });
                    history.push("/")
                }
            } catch (e) {
                setAlertMessage({
                    open: true,
                    message: "Please try again!",
                    alertSuccess: false,
                });

                // console.log(e);
            }
        }
    };
    const handleAmount = (e) => {
        isNaN(parseFloat(e.target.value))
            ? setAmount()
            : setAmount(parseFloat(e.target.value));
    };

    useEffect(() => {
        if (type == "qp") {
            getStore(id);
        }

        if (type == "in") {
            orderInvoiceIn();
        }
        if (appState.loggedIn) {
            if (appState.profile) {
                let mobile;
                if (appState.profile.mobile_no) {
                    let mob = appState.profile.mobile_no;
                    let sliced = mob.slice(4, 9);
                    let st = "*";
                    let stArr = [];
                    let mobLe = mob.slice(9, mob.length).length;
                    for (let i = 0; i < mobLe; i++) {
                        st += "*";
                    }
                    mobile = `***${sliced}${st}`;
                }
            }
        }
    }, []);

    const AddInfo = () => {
        setAdditionalInfo(!additionalInfo);
    };
    const handleFormChange = (props) => (e) => {
        setFormData({
            ...formData,
            [props]: e.target.value,
        });
    };
    useEffect(() => {
        localStorage.setItem("fields", JSON.stringify(field));
    }, [field]);

    useEffect(() => {
        if (tapId != "" && tapId != undefined) {
            payInvoices();
        }
    }, [tapId]);

    useEffect(() => {
        setTimeout(() => {
            setAlertMessage({ open: false, message: "", alertSuccess: false });
        }, 8000);
    }, [alertMessage.open]);

    useEffect(async () => {
        setIsLoading(true);

        if (customer != {}) {
            setFormData({
                ...formData,
                name: customer.name,
                email: customer.email,
                number: customer.number,
                country_code: customer.country_code,
            });
        }
    }, [customer]);

    const handleTryAgain = () => {
        setTryAgain(true)
    }

    if (isLoading)
        return (
            <div className={`${classes.root} ${classes.height}`}>
                <LoaderAnimation />
            </div>
        );
    return (invoiceDetails.status == "Paid" ||
        invoiceDetails.status == "Direct" ||
        invoiceDetails.status == "Failed") && tryAgain == false ? (
        <Invoice
            invoiceDetail={invoiceDetails}
            Amount={amount}
            handleTryAgain={handleTryAgain}
        />
    ) : (
        <>
            {" "}
            {appState.freezScreen && (
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={appState.freezScreen}
                >
                    <LoaderAnimation />
                </Backdrop>
            )}
            <section
                id="payments"
                className={`${pLoading ? "disableClass" : ""
                    } d-flex flex-column justify-content-center pb-4`}
            >

                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={alertMessage.open}
                    className={
                        alertMessage.alertSuccess ? "success-alert" : "danger-alert"
                    }
                >
                    {alertMessage.alertSuccess ? (
                        <Alert severity="success">{alertMessage.message}</Alert>
                    ) : (
                        <Alert severity="error">{alertMessage.message}</Alert>
                    )}
                </Snackbar>

                <div className="container ">
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-6 bg-white p-0">
                            <MiscBanner cover={store.cover}>
                                <div className="container">
                                    <section id="info">
                                        {/* <section id="info"className="col-10 offset-1"> */}
                                        <div className="row m-0 py-2 align-items-center">
                                            <div className="logoImg">
                                                {/* <img
                    src={store.logo ? store.logo : ""}
                    className="img-fluid"
                    alt=""
                  /> */}
                                                <img
                                                    src={
                                                        store.logo
                                                            ? `${store.logo}`
                                                            : `${process.env.REACT_APP_IMAGE_URL}brandLogo.png`
                                                    }
                                                    className="img-fluid"
                                                    width="55"
                                                    alt=""
                                                />
                                            </div>
                                            <div
                                                className={`infoContent px-3  ${appState.langValue === "ar"
                                                    ? "d-flex flex-column align-items-start "
                                                    : ""
                                                    }`}
                                            >
                                                {/* <p className="small m-0 text-primary">Mall Based Store</p> */}
                                                <h5 className="mb-1">
                                                    {type === "in"
                                                        ? store.business_name
                                                        : store.business_name}
                                                </h5>
                                                {/*<p class="small">Lorem ipsum Lorem</p> */}
                                                <p className="m-0">
                                                    {store.address ? store.address : ""}
                                                </p>
                                            </div>
                                            <div
                                                className={`infoIcon ${appState.langValue === "ar" ? "mr-auto" : "ml-auto"
                                                    }`}
                                            >
                                                <CheckCircleIcon className="text-primary" />
                                            </div>
                                        </div>

                                        {type === "in" ? (
                                            <>
                                                <div className={`am_loggedIn`}>
                                                    <div className="row m-0 align-items-center">
                                                        <p className="col m-0 text-left">
                                                            <strong>Amount</strong>
                                                        </p>
                                                        <p className="col m-0 text-center">{amount}</p>
                                                        <p className="col m-0 text-right">{t("KWD")}</p>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </section>
                                </div>
                            </MiscBanner>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-6 bg-light  pb-3">
                            <div
                                className={
                                    type === "in"
                                        ? "container-div invoice-store"
                                        : "container-div"
                                }
                            >
                                <main>

                                    {/* <h1 className="text-secondary mb-3">Payment</h1> */}

                                    <section id="fields">
                                        <>
                                            {type == "qp" ? (
                                                <div className="amountFieldContainer py-3">
                                                    <div className="row m-0 align-items-center WalletRow">
                                                        <div className="col-md-12 p-0 py-2 ">
                                                            <h6>Amount</h6>
                                                        </div>
                                                        <div className="col-md-12 p-0">
                                                            <div className="WalletInfomration ">
                                                                <OutlinedInput
                                                                    id="standard-adornment-weight"
                                                                    value={amount}
                                                                    type="number"
                                                                    placeholder="0"
                                                                    onChange={handleAmount}
                                                                    className="border-0 w-100 text-center amount-field "
                                                                    endAdornment={
                                                                        <InputAdornment
                                                                            position="end"
                                                                            className="text-muted"
                                                                        >
                                                                            {t("KWD")}
                                                                        </InputAdornment>
                                                                    }
                                                                />
                                                            </div>
                                                            {/* <span className="text-secondary"><strong>{t("KWD")}</strong></span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}

                                            <div

                                                className={`${type == "in" ? "" : ""
                                                    } row mx-2 align-items-center WalletRow`}
                                            >
                                                <div className="col-md-12 p-0  InputPhoneInvoice">
                                                    <div className="invoiceInputs ">
                                                        <TextField
                                                            variant="outlined"
                                                            value={
                                                                appState.loggedIn
                                                                    ? appState.profile.number
                                                                    : formData.number
                                                            }
                                                            onChange={handleFormChange("number")}
                                                            onInput={(e) => {
                                                                e.target.value = Math.max(
                                                                    0,
                                                                    parseInt(e.target.value)
                                                                )
                                                                    .toString()
                                                                    .slice(0, 8);
                                                            }}
                                                            name="phoneNumer"
                                                            type="number"
                                                            label="Phone Number"
                                                            autoFocus={true}
                                                            className="border-0 w-100 phone-field mt-2"
                                                            disabled={appState.loggedIn}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>

                                        <p className="p-0 m-0 mt-2">
                                            <Button onClick={AddInfo}>
                                                {additionalInfo ? (
                                                    <span className="text-blue-payment"> -</span>
                                                ) : (
                                                    <span className="text-blue-payment"> +</span>
                                                )}
                                                <span className="mx-3 text-blue-payment text-capitalize">
                                                    Add Optional Info
                                                </span>{" "}
                                            </Button>
                                        </p>
                                        {additionalInfo ? (
                                            <>
                                                <div className="additionalInfo mt-2 row mx-2">
                                                    <div className="col-md-12 p-0">
                                                        <div className="invoiceInputs">
                                                            {/* <TextField placeholder="0.0" onChange={handleInpValue} value={parseFloat(inpValue)} type="number" /> */}
                                                            <TextField
                                                                variant="outlined"
                                                                value={
                                                                    appState.loggedIn
                                                                        ? appState.profile.userFirstName
                                                                        : formData.name
                                                                }
                                                                onChange={handleFormChange("name")}
                                                                name="name"
                                                                label="Name"
                                                                type="text"
                                                                autoFocus={true}
                                                                className="border-0 w-100 phone-field"
                                                                disabled={appState.loggedIn}
                                                            />
                                                        </div>
                                                        {/* <span className="text-secondary"><strong>{t("KWD")}</strong></span> */}
                                                    </div>
                                                </div>

                                                <div className="additionalInfo row mx-2 pt-3 pb-5">
                                                    <div className="col-md-12 p-0">
                                                        <div className="invoiceInputs">
                                                            {/* <TextField placeholder="0.0" onChange={handleInpValue} value={parseFloat(inpValue)} type="number" /> */}
                                                            <TextField
                                                                variant="outlined"
                                                                value={
                                                                    appState.loggedIn
                                                                        ? appState.profile
                                                                            ? appState.profile.email
                                                                            : formData.email
                                                                        : formData.email
                                                                }
                                                                onChange={handleFormChange("email")}
                                                                name="email"
                                                                label="Email Address"
                                                                type="text"
                                                                autoFocus={true}
                                                                className="border-0 w-100 phone-field"
                                                                disabled={appState.loggedIn}
                                                            />
                                                        </div>
                                                        {/* <span className="text-secondary"><strong>{t("KWD")}</strong></span> */}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </section>

                                    {/*  */}
                                    <Payments
                                        store={store}
                                        handlePaymentChange={handlePaymentChange}
                                        payWithValue={payWithValue}
                                        paymentSource={paymentSource}
                                        childRef={childRef}
                                        amount={amount}
                                        setButtonLoading={setButtonLoading}
                                        setTapId={setTapId}
                                        setAlertMessage={setAlertMessage}
                                    />
                                    {invoiceDetails ? (
                                        invoiceDetails.status === "Paid" ? (
                                            ""
                                        ) : (
                                            <div className="text-center mb-2 m-0 p-0">
                                                <div className={classes.root}>
                                                    <div className={classes.wrapper}>
                                                        <Button
                                                            variant="contained"
                                                            disabled={buttonLoading}
                                                            onClick={handleSubmit}
                                                            className="col-12 bg-primary"
                                                        >
                                                            {buttonLoading ? "Processing" : "Confirm & Pay"}
                                                        </Button>
                                                        {buttonLoading && (
                                                            <CircularProgress
                                                                size={24}
                                                                className={classes.buttonProgress}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    ) : (
                                        <div className="text-center mt-4">
                                            <div className={classes.root}>
                                                <div className={classes.wrapper}>
                                                    <Button
                                                        variant="contained"
                                                        disabled={buttonLoading}
                                                        onClick={handleSubmit}
                                                        className="col-12 bg-primary"
                                                    >
                                                        {buttonLoading ? "Processing" : "Confirm & Pay"}
                                                    </Button>
                                                    {buttonLoading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={classes.buttonProgress}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

const Payments = (props) => {
    const appDispatch = useContext(DispatchContext);
    const appState = useContext(StateContext);
    const [seeMore, setSeeMore] = useState(1);
    const {t} = useTranslation()

    const [isLoading, setIsLoading] = useState("");
    const [open, setOpen] = useState(false);

    const [openModal, setOpenModal] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false)
    }
    const handlChangeView = () => {
        if (appState.cardList.length > seeMore) {
            setSeeMore(seeMore + 1)
        }
        else {
            setSeeMore(1)
        }
    };
    const handleClickLogin = () => {
        appDispatch({ type: "setLoginModal", loginModal: true });

    };
    const handleCloseLogin = () => {
        setOpenModal(false);
    };
    return (
        <>
            <CustomizedDialogs open={open} handleClose={handleClose} setAlertMessage={props.setAlertMessage} />

            <LoginModal closeBtn={true} />
            <section className="payWith row m-0">
                <div className="payWith col-md-12 px-0">
                    <h6 className=" pl-2 mt-3">Pay With</h6>

                    <div
                        className="row m-0"
                        onChange={(e) => props.handlePaymentChange(e)}
                    >
                        {props.store.payments ? props.store.payments.includes("save_card") ? appState.loggedIn
                            ? appState.cardList != null
                                ? appState.cardList.slice(0, seeMore).map((val, ind) => {
                                    return (
                                        <div style={{border:"2px solid red"}} className="col-12  p-0">
                                            <div className="paymentContainer">
                                                <input
                                                    type="radio"
                                                    checked={props.payWithValue == val.id}
                                                    value={val.id}
                                                    name="paymentMethod"
                                                    id={`paymentSaveCard-${val.id}`}
                                                />
                                                <label htmlFor={`paymentSaveCard-${val.id}`}>
                                                    <div className="payment-method">
                                                        <span className="px-4">
                                                            <img
                                                                src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                                                alt=""
                                                                width="30"
                                                            />
                                                        </span>
                                                        <span className="px-4 ">
                                                            <h4 className="mt-2 text-capitalize">
                                                                {val.type}
                                                                <p className="text-muted">
                                                                    {" "}
                                                                    **** **** **** {val.last_four}
                                                                </p>
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    );
                                })
                                : ""
                            : ""
                            : ""

                            : ""}

                        {props.store.payments ? props.store.payments.includes("save_card") ?
                            appState.loggedIn ? (
                                appState.cardList != null ? (
                                    <div className="col-12 d-flex justify-content-end mb-2">
                                        <Button
                                            variant="text"
                                            className="text-capitalize"
                                            onClick={handlChangeView}
                                        >
                                            {" "}
                                            {seeMore < appState.cardList.length ? "See More" : "See Less"}{" "}
                                        </Button>
                                    </div>
                                ) : (
                                    ""
                                )
                            ) : (
                                ""
                            )
                            : ""
                            : ""}

                        {/* wallet */}
                        <div className="col-12 paymentContainer p-0 ">
                            <div>
                                <input
                                    type="radio"
                                    checked={props.payWithValue === "wallet"}
                                    disabled
                                    value="wallet"
                                    name="wallet"
                                    id="paymentWallet"
                                />
                                <label htmlFor="paymentWallet">
                                    <div className="payment-method">
                                        <span className="px-4">
                                            <img
                                                className="img-fluid"
                                                width="30"
                                                src={vendorsConfig.APP_ICON}
                                                alt={vendorsConfig.APP_NAME}
                                            />
                                        </span>

                                        <span className="px-4">
                                            <h5 className="mt-2 d-flex">{vendorsConfig.APP_NAME}</h5>
                                            {appState.loggedIn ? (
                                                <h6 className="text-muted d-flex">
                                                    {appState.profile.walletAmount
                                                        ? parseFloat(appState.profile.walletAmount)
                                                        : "0"}{" "}
                                                    {t("KWD")}
                                                </h6>
                                            ) : (
                                                ""
                                            )}
                                        </span>
                                        <span
                                            className={`pr-3 ${appState.langValue === "ar" ? "mr-auto" : "ml-auto"
                                                }`}
                                        >
                                            {/* <Button variant="contained" color="primary" onClick={handleClickOpen}>
                                    Top Up
  </Button> */}
                                            {appState.loggedIn ? (
                                                <div className="customizeDialog ">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleClickOpen}
                                                        className="p-0 px-2"
                                                    >
                                                        {" "}
                                                        Top Up{" "}
                                                    </Button>
                                                </div>
                                            ) : (
                                                <div className="customizeDialog">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={handleClickLogin}
                                                        className="p-0 px-2"
                                                    >
                                                        {" "}
                                                        Top Up{" "}
                                                    </Button>
                                                </div>
                                            )}
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        {/* {appState.cardList
            ? appState.cardList.map((val, ind) => {
                return (
                  <div className="col-12 paymentContainer p-0">
                    <div>
                      <input
                        type="radio"
                        checked={props.payWithValue === "val.type"}
                        value="Master"
                        name="paymentMethod"
                        id="paymentMaster"
                      />
                      <label htmlFor="paymentMaster">
                        <div className="payment-method">
                          <span className="px-4">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                              alt=""
                              width="30"
                            />
                          </span>
                          <span className="px-4 ">
                            <h4 className="mt-2 text-capitalize">
                              {val.type}
                              <p className="text-muted">
                                {" "}
                                **** **** **** {val.last_four}
                              </p>
                            </h4>
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                );
              })
            : ""} */}
                        {/* knet */}
                        <div className="col-12 paymentContainer p-0 ">
                            <div>
                                <input
                                    type="radio"
                                    checked={props.payWithValue === "knet"}
                                    id="paymentKnet"
                                    value="knet"
                                    name="knet"
                                />
                                <label htmlFor="paymentKnet">
                                    <div className="payment-method">
                                        <span className="px-4">
                                            <img
                                                src={`${process.env.REACT_APP_IMAGE_URL}Knet.png`}
                                                alt=""
                                                width="30"
                                            />
                                        </span>
                                        <span className="px-4">
                                            <h4 className="mt-2">Knet</h4>
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>
                        {/* card */}

                        {props.store.payments ? props.store.payments.includes("card") &&
                            <div className="col-12 paymentContainer p-0 ">
                                <div>
                                    <input
                                        type="radio"
                                        checked={props.payWithValue === "card"}
                                        id="paymentCard"
                                        value="card"
                                        name="card"
                                    />
                                    <label htmlFor="paymentCard">
                                        <div className="payment-method">
                                            <span className="px-4">
                                                <img
                                                    src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                                    alt=""
                                                    width="30"
                                                />
                                            </span>
                                            <span className="px-4">
                                                <h4 className="mt-2">Card</h4>
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            </div> : ""}

                    </div>
                </div>

                {props.payWithValue == "card" ? (
                    <div className="col-12  d-flex align-items-center justify-content-center">
                        <GoSellElementsTrans

                            tapkey={props.store.key}

                            status={"invoice"}
                            ref={props.childRef}
                            inpValue={props.amount}
                            setTapId={props.setTapId}
                            payWithValue={props.payWithValue}
                            setButtonLoading={props.setButtonLoading}
                        />
                    </div>
                ) : (
                    ""
                )}
            </section>
        </>
    );
};

export default withTranslation() (OldPayment);
